import React from 'react';
import './styles/HowItWorks.css';

const HowItWorks: React.FC = () => {
  return (
    <div className="how-it-works-container">
      <h2 className="how-it-works-title">How it Works</h2>
      
      <div className="how-it-works-cards-row">
        <div className="how-it-works-card">
          <div className="how-it-works-icon-circle">
            <img 
              src="/icon/orderhome.png"
              alt="Browse & Discover"
              className="how-it-works-card-icon"
            />
          </div>
          <h3 className="how-it-works-card-title">Browse & Discover</h3>
          <p className="how-it-works-card-description">
            All building materials and renovation needs in one app.
          </p>
        </div>

        <div className="how-it-works-card">
          <div className="how-it-works-icon-circle">
            <img 
              src="/icon/ordericon.png"
              alt="Order Instantly"
              className="how-it-works-card-icon"
            />
          </div>
          <h3 className="how-it-works-card-title">Order Instantly</h3>
          <p className="how-it-works-card-description">
            Add Products and book expert services in seconds.
          </p>
        </div>

        <div className="how-it-works-card">
          <div className="how-it-works-icon-circle">
            <img 
              src="/icon/delevryicon.png"
              alt="Get Fast Delivery & Services"
              className="how-it-works-card-icon"
            />
          </div>
          <h3 className="how-it-works-card-title">Get Fast Delivery & Services</h3>
          <p className="how-it-works-card-description">
            Materials delivered in minutes. Professionals instantly booked
          </p>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;